import { FC, memo, PropsWithChildren, useMemo } from 'react';

import { dom, uuid } from 'app/utils';
import { Tooltip } from './tooltip';
import { IComponent, ITooltipOptions } from '../types';

const icons: Record<string, (name: string, variant?: string, filled?: boolean) => any> = {
  'lni': (name) => ({
    className: dom.className('lni', name),
  }),
  'mdi': (name, variant, filled) => ({
    className: dom.className('mdi', `mdi-${variant ?? 'outlined'}`, { 'mdi-filled': filled }, name),
  }),
  'msi': (name, variant, filled) => ({
    className: dom.className('msi', `msi-${variant ?? 'outlined'}`, { 'msi-filled': filled }),
    children: name,
  }),
  'pi': (name) => ({
    className: dom.className('pi', name),
  }),
};

export interface IIcon extends PropsWithChildren<IComponent> {
  name: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  tooltip?: string | ITooltipOptions;

  variant?: 'outlined' | 'rounded'| 'sharp';
  filled?: boolean;
}

export const Icon: FC<IIcon> = memo(({ id, className, style, disabled, name, size, tooltip, variant, filled }) => {
  const keys = Object.keys(icons), key = (keys.find(i => name.startsWith(i)) ?? 'msi');
  const base =  icons[key](name, variant, filled);

  if (typeof tooltip === 'string') tooltip = { label: tooltip, position: 'bottom' };

  const identifier = useMemo(() => uuid.v4(), []);
  const props: any = { ...base, id, style, disabled,
    className: dom.className('i-component', 'i-icon', `i-${size ?? 'md'}`, base.className, className),

    'data-pc-id': identifier,
  };

  return (
    <>
      <span { ...props } data-pc-section="icon" />
      {tooltip && <Tooltip { ...tooltip } target={`.i-icon[data-pc-id="${identifier}"]`} />}
    </>
  );
});
